import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from 'angularfire2/firestore';
import { FirestoreService } from './firestore/firestore.service';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/combineLatest';
import 'rxjs/add/operator/mergeMap';

import { Globals } from '../globals';
import { Console } from '@angular/core/src/console';

export interface Stock {
  warehouseRef: string;
  totalStock: number;
  productStock: ProductStock[];
}

interface ProductStock {
  productRef: any;
  quantity: number;
}

@Injectable()
export class StockService {

  collection: string;
  transactionRef: string;
  productCmpaRef: string;
  productVntaRef: string;

  constructor(
    private afs: AngularFirestore,
    private afh: FirestoreService,
    private router: Router,
  ) {
    this.collection = Globals.STOCK_COLLECTION;
    this.transactionRef = Globals.TRANSACTION_COLLECTION;
    this.productCmpaRef = Globals.PRCMPA_COLLECTION;
    this.productVntaRef = Globals.PRVNTA_COLLECTION;
  }

  // Get stock form a specific product in a specific warehouse
  getProductStock(warehouseId: string, productId: string){
    return this.afh.doc$(`stock/${warehouseId}/productsInWarehouse/${productId}`);
  }

  getWarehouseStock(warehouseId: string) {
    return this.afh.doc$(`stock/${warehouseId}`);
  }

}
